import { createContext } from 'react';

export const SocketDispatch = createContext(null);